/**
 * Created by ndzak on 4/23/2016.
 */

import Repo from '../repos/Repo';

export default class PremadeCommentRepo extends Repo{

    constructor($auth){
        super($auth, 'premade-comments');
    }

    all(q){
        return super.all(q, "")
    }

    store(data){
        return super.store(data, "")
    }

    update(id, data){
        return super.update(id, data, "")
    }

    get(id){
        return super.get(id, "")
    }
}


// WEBPACK FOOTER //
// ./src/repos/PremadeCommentRepo.js